import { EPartsLower } from '../../../types/fio';

export function getCurrentPartFIO(query: string[]) {
  if (query.length === 2) {
    return EPartsLower.name;
  }

  if (query.length === 3) {
    return EPartsLower.patronymic;
  }

  return EPartsLower.surname;
}
